const API_URL = "/.netlify/functions/";
//const API_URL = "http://localhost:8888/.netlify/functions/";

module.exports = {
  API_URL,
};
